import React, { useMemo, useState } from 'react'

import { STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'

import useRecommendation from '../hooks/useRecommendation'
import { useProductPageExpData } from '../templates/productPage/productPage.utils'

import ProductPageContext from './ProductPageContext'

interface ProductPageContextProviderProps {
  children: React.ReactNode
  showFullPDP?: boolean
  updateShowFullPDPInSession?: (val: boolean) => void
}

const ProductPageContextProvider = ({
  children,
  showFullPDP = false,
  updateShowFullPDPInSession = (_: boolean) => {
    //Empty
  },
}: ProductPageContextProviderProps) => {
  const { productPageExpData, similarProductExpData } = useProductPageExpData(showFullPDP)
  const { recommendationUIData, isRecommendationLoading, updateRecommendationAPIData } =
    useRecommendation(productPageExpData)
  const [hasMoreToExplore, setHasMoreToExplore] = useState<boolean>(false)

  const { experimentBucket, init } = useStatsigExperiment(STATSIG_EXPERIMENTS.USE_NEW_PDP_RECOMMENDATIONS)

  const newPDPRecommendations = {
    isInBucket:
      experimentBucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.USE_NEW_PDP_RECOMMENDATIONS].buckets?.show,
    isInitialized: init,
  }

  const value = useMemo(
    () => ({
      isRecommendationLoading,
      updateRecommendationAPIData,
      hasMoreToExplore,
      setHasMoreToExplore,
      productPageExpData,
      showFullPDP,
      setShowFullPDP: updateShowFullPDPInSession,
      similarProductExpData,
    }),
    [isRecommendationLoading, hasMoreToExplore, productPageExpData, showFullPDP, similarProductExpData],
  )
  return (
    <ProductPageContext.Provider value={{ ...value, recommendationUIData, newPDPRecommendations }}>
      {children}
    </ProductPageContext.Provider>
  )
}

export default ProductPageContextProvider
